import { LANG_NAMES, lang, t } from './i18n.ts';

/** The top bar. The public pages do not point to the administrator's pages; they carry the language choice. */
export function topbar(active: 'market' | 'admin'): string {
  if (active === 'admin') {
    return `<header class="topbar"><a class="brand" href="#/market"><span class="logo">O</span><span class="brand-text">Otoha 市场</span></a>
      <div class="spacer"></div><span class="dim" style="padding-right:12px">管理后台</span></header>`;
  }
  const options = Object.entries(LANG_NAMES).map(([code, name]) => `<option value="${code}"${code === lang() ? ' selected' : ''}>${name}</option>`).join('');
  return `<header class="topbar"><a class="brand" href="#/market"><span class="logo">O</span><span class="brand-text">${t('marketName')}</span></a>
    <div class="spacer"></div><select class="lang-select" id="lang" aria-label="${t('language')}">${options}</select></header>`;
}
